import { ValueLists, CrudMode } from '@ohpen/enso-ui';
import { ActionEntityType, FieldType, ActionType } from '@pmp/api';
import type { Resource } from '@pmp/contexts';

export * from './lockActionTitle';
export * from './schemaFormCheckbox';
export * from './crudMode';
export * from './notificationMessage';
export * from './exclusivesRedirectPath';
export * from './apiClient';
export * from './getOidcConfig';
export * from './listUrlState';
export * from './linkedToActiveToday';
export * from './translatedEnum';
export * from './dateTime';
export * from './actionStatusTags';
export * from './fieldMaxLengths';
export * from './sequentialCode';

export const actionEntityTypeToTranslationKey = {
  [ActionEntityType.PRODUCTS]: 'products',
  [ActionEntityType.BASE_RATES]: 'baseRates',
  [ActionEntityType.ERC_PROFILES]: 'erc',
  [ActionEntityType.FEES]: 'fees',
  [ActionEntityType.FEE_PROFILES]: 'fees',
  [ActionEntityType.EXCLUSIVITY_SETS]: 'exclusiveProducts',
  [ActionEntityType.EXCHANGE_RATES]: 'exchangeRates',
  [ActionEntityType.LENDERS]: 'lender',
  [ActionEntityType.DEFAULT_PROCURATION_FEE_ASSIGNMENTS]: 'lender',
  [ActionEntityType.PROCURATION_FEES]: 'procurationFees',
  [ActionEntityType.FIRMS]: 'firms',
  [ActionEntityType.FIRM_PROCURATION_FEE_ASSIGNMENTS]: 'firms',
  [ActionEntityType.BROKERS]: 'brokers',
  [ActionEntityType.PROCURATION_FEE_RULES]: 'procurationFees',
  [ActionEntityType.INTEREST_RATES]: 'interestRates',
};

export const actionEntityTypeToPermissions = {
  [ActionEntityType.LENDERS]: 'lenders',
  [ActionEntityType.DEFAULT_PROCURATION_FEE_ASSIGNMENTS]: 'lenders',
  [ActionEntityType.FIRMS]: 'firms',
  [ActionEntityType.FIRM_PROCURATION_FEE_ASSIGNMENTS]: 'firms',
  [ActionEntityType.BROKERS]: 'brokers',
  [ActionEntityType.PROCURATION_FEES]: 'procurationFees',
  [ActionEntityType.PROCURATION_FEE_RULES]: 'procurationFees',
  [ActionEntityType.PRODUCTS]: 'products',
  [ActionEntityType.BASE_RATES]: 'baseRates',
  [ActionEntityType.INTEREST_RATES]: 'baseRates',
  [ActionEntityType.EXCHANGE_RATES]: 'exchangeRates',
  [ActionEntityType.ERC_PROFILES]: 'ercProfiles',
  [ActionEntityType.FEES]: 'fees',
  [ActionEntityType.FEE_PROFILES]: 'feeProfiles',
  [ActionEntityType.EXCLUSIVITY_SETS]: 'exclusivitySets',
} as const satisfies Record<ActionEntityType, Resource>;

export const OPERATION_ORDER = ['ADVICE', 'PACKAGE', 'NETWORK', 'MORTGAGE_CLUB'];

export const crudToActionMap: Partial<Record<CrudMode, ActionType>> = {
  [CrudMode.CREATE]: ActionType.CREATE,
  [CrudMode.EDIT]: ActionType.EDIT,
  [CrudMode.BULK_EDIT]: ActionType.EDIT,
  [CrudMode.CLONE]: ActionType.CLONE,
  [CrudMode.BULK_CLONE]: ActionType.CLONE,
  [CrudMode.IMPORT]: ActionType.IMPORT,
};

export function getFilteredEntityTypeList(valueLists: ValueLists, entityTypes: ActionEntityType[]): { [k: string]: string } {
  const entityTypeList = valueLists[FieldType.ACTION_ENTITY_TYPE];
  if (!entityTypeList) return {};
  return Object.fromEntries(entityTypes.filter(key => key in entityTypeList).map(key => [key, entityTypeList[key]]));
}

export { createDeleteErrorException, getApiErrorDetail, getApiErrorMessage } from './errorHandling';
export * from './customFields';
export * from './parameters';
